// @ts-nocheck
import { titleCase } from 'title-case';
import startCase from 'lodash.startcase';

export function isObjectEmpty(obj = {}) {
  return Object.keys(obj).length === 0;
}

export function slugify(str) {
  return str
    .toLowerCase() // Convert the string to lowercase
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/[^\w-]+/g, '') // Remove special characters
    .replace(/--+/g, '-') // Replace multiple consecutive hyphens with a single hyphen
    .replace(/^-|-$/g, ''); // Remove leading and trailing hyphens
}

export function generateRandomString(len = 4) {
  const letters = 'abcdefghijklmnopqrstuvwxyz';

  let result = '';

  for (let i = 0; i < len; i += 1) {
    const randomIndex = Math.floor(Math.random() * letters.length);
    result += letters.charAt(randomIndex);
  }

  return result;
}

export function toTitleCase(str) {
  return titleCase(startCase(str.replace(/_/gi, ' ')));
}

export function generateUuidV4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export function maskStringExceptFirstAndLastTwoChars(str, maskLength) {
  if (str.length <= 4) {
    return str;
  }

  const start = str.substr(0, 2);
  const end = str.substr(-2);
  const masked = '*'.repeat(maskLength ?? str.length - 4);

  return start + masked + end;
}
